$(document).ready(function () {
    $(document).on("click", ".custom_contact_form .custom_contact_tab p.custom_contact_tabIn", function () {
        $(".custom_contact_form .custom_contact_tab p.custom_contact_tabIn").removeClass("active");
        $(this).addClass("active");
        var data_handle = $(this).attr("data-handle");
        $(".custom_contact_form .tab_data_main").hide();
        $(".custom_contact_form .tab_data_main[data-handle='" + data_handle + "']").show();
    });
    var mySwiper = new Swiper(".custom_slideshow-wrapper .swiper-container", {
        freeMode: !0,
        slidesPerView: 4.5,
        spaceBetween: 32,
        scrollbar: { el: ".swiper-scrollbar", draggable: !0, snapOnRelease: !1 },
        breakpoints: { 1025: { slidesPerView: 4.5, spaceBetween: 32 }, 768: { slidesPerView: 3.5, spaceBetween: 20 }, 320: { slidesPerView: 1.2, spaceBetween: 12 } },
    });
  
    $(".label-input-cross-wrapp input.input-full").each(function () {
        if ($(this).val().length == 0) {
            $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
        } else {
            $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
        }
    });
    $(".label-input-cross-wrapp input.input-full").focus(function () {
        $(".label-input-cross-wrapp input.input-full").each(function () {
            if ($(this).val().length == 0) {
                $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
            }
        });
        $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
    });
    $(".label-input-cross-wrapp label.form-label").click(function () {
        $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
        $(this).parents(".label-input-cross-wrapp").find("input").focus();
    });
    $(".label-input-cross-wrapp .cross_input").click(function () {
        $(this).parents(".label-input-cross-wrapp").find("input").val("");
        $(this).parents(".label-input-cross-wrapp").find("input").blur();
    });
    $(".label-input-cross-wrapp input.input-full").blur(function () {
        $(".label-input-cross-wrapp input.input-full").each(function () {
            if ($(this).val().length == 0) {
                $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
            } else {
                $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
            }
        });
    });
});
